module.exports = __webpack_public_path__ + "img/battery.99363de0.svg";